<template>
	<a-radio-group v-model="val" @change="handleChange" :style="{ '--num': num, '--btn-height': btnHeight, '--btn-radius': btnRadius, '--min-width': minWidth }">
		<a-tooltip :title="item.tip" overlayClassName="download-title-tip" v-for="item of options" :key="item[optionValue]">
			<a-radio-button :value="Number(item[optionValue])">{{ item[optionLabel] }}</a-radio-button>
		</a-tooltip>
	</a-radio-group>
</template>

<script>
export default {
	name: 'MyRadioButton',
	model: {
		prop: 'value',
		event: 'update',
	},
	props: {
		value: {
			type: Number,
			default: 0,
		},
		options: {
			type: Array,
			default: () => {
				return [];
			},
		},
		optionLabel: { type: String, default: 'label' },
		optionValue: { type: String, default: 'value' },
		num: { type: Number, default: 5 },
		btnHeight: { type: String, default: '32px' },
		btnRadius: { type: String, default: '6px' },
		minWidth: { type: String, default: '60px' },
	},
	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(n) {
				this.val = n;
			},
		},
	},
	components: {},
	data() {
		return {
			val: '',
		};
	},
	mounted() {},
	methods: {
		handleChange() {
			this.$emit('update', this.val);
			this.$emit('change', this.val);
		},
	},
};
</script>

<style scoped lang='scss'>
// 单选按钮
.ant-radio-group {
	--border-color: #ebecf0;
	--color: #222;
	--btn-margin-horizontal: 5px;
	--btn-margin-vertical: 12px;

	display: flex;
	flex-wrap: wrap;
	.ant-radio-button-wrapper {
		min-width: var(--min-width);
		width: calc((100% - (var(--btn-margin-horizontal) * 2) * var(--num)) / var(--num));
		height: var(--btn-height);
		@include fcc();
		border-radius: var(--btn-radius);
		border: 1px solid var(--border-color);
		box-shadow: 0px 2px 8px -2px rgba(0, 0, 0, 0.04);
		box-sizing: border-box;
		font-weight: 400;
		color: var(--color);
		margin-right: 10px;
		padding: 0 6px;
		font-size: 14px;
		font-weight: 400;
		background-color: $white;
		&.ant-radio-button-wrapper-checked {
			color: $modal_primary;
			border-color: $modal_primary;
			background: $white;
		}
		&:not(:first-child)::before {
			display: none;
		}
	}
}
</style>